<template>
  <div>
    <v-dialog
      v-model="editDialog.show"
      scrollable
      persistent
      :max-width="$spec.dialog_standard_max_width"
    >
      <v-card>
        <v-card-title class="headline">編輯個人資訊</v-card-title>
        <v-card-text>
          <v-form ref="editForm">
            <v-text-field v-model="editDialog.name" :rules="editDialog.nameRules" label="姓名"></v-text-field>
            <v-text-field v-model="editDialog.phone" label="電話" disabled></v-text-field>
            <v-text-field
              label="密碼"
              v-model="passwordSymbol"
              :disabled="$my.getPermission() !== 'role_admin' && $my.getPermission() !== 'role_superadmin'"
              append-icon="mdi-shield-edit"
              readonly
              class="overline"
              @click:append="showUpdatePasswordDialog"
            ></v-text-field>
            <v-select
              v-model="editDialog.permission"
              :items="editDialog.permissionItems"
              label="權限"
              :disabled="
                ($my.getPermission() !== 'role_admin' && $my.getPermission() !== 'role_superadmin') ||
                  editDialog.permission === 'role_admin'
              "
            ></v-select>
            <v-text-field label="群組" v-model="editDialog.clinic" disabled></v-text-field>
            <v-textarea
              v-model="editDialog.info"
              label="備註"
              counter="300"
              :rules="editDialog.infoRules"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="editDialog.show = false">取消</v-btn>
          <v-btn color="green" text @click="updateProfile()" :loading="editDialog.loading">儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="updatePasswordDialog.show"
      persistent
      :max-width="$spec.dialog_standard_max_width"
    >
      <v-card>
        <v-card-title class="headline">重設密碼</v-card-title>
        <v-card-text>
          <v-form ref="updatePasswordForm">
            <v-text-field
              label="新密碼"
              v-model="updatePasswordDialog.new"
              :rules="updatePasswordDialog.newRules"
              :append-icon="
                updatePasswordDialog.showNew ? 'mdi-eye' : 'mdi-eye-off'
              "
              :type="updatePasswordDialog.showNew ? 'text' : 'password'"
              @click:append="
                updatePasswordDialog.showNew = !updatePasswordDialog.showNew
              "
            ></v-text-field>
            <v-text-field
              label="確認新密碼"
              v-model="updatePasswordDialog.again"
              :rules="updatePasswordDialog.againRules"
              :append-icon="
                updatePasswordDialog.showAgain ? 'mdi-eye' : 'mdi-eye-off'
              "
              :type="updatePasswordDialog.showAgain ? 'text' : 'password'"
              @click:append="
                updatePasswordDialog.showAgain = !updatePasswordDialog.showAgain
              "
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="updatePasswordDialog.show = false">取消</v-btn>
          <v-btn
            color="green"
            text
            @click="updatePassword()"
            :loading="updatePasswordDialog.loading"
          >儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: thisVm => ({
    passwordSymbol: "",
    editDialog: {
      show: false,
      phone: "",
      name: "",
      nameRules: [v => !!v || "請輸入姓名"],
      permission: "",
      permissionItems: [
        { text: "使用者", value: "role_user" },
        { text: "員工", value: "role_staff" }
      ],
      clinic: "",
      info: "",
      infoRules: [v => !v || v.length <= 300 || "最多300字元"],
      loading: false
    },
    updatePasswordDialog: {
      show: false,
      new: "",
      newRules: [
        v => !!v || "請輸入新密碼",
        v => (v && v.length >= 4) || "密碼長度需超過4個字元"
      ],
      showNew: false,
      again: "",
      againRules: [
        v => !!v || "請重新輸入密碼",
        v => (v && v.length >= 4) || "密碼長度需超過4個字元",
        () => {
          if (
            thisVm.updatePasswordDialog.new !==
            thisVm.updatePasswordDialog.again
          ) {
            return "密碼不一致";
          } else {
            return true;
          }
        }
      ],
      showAgain: false,
      loading: false
    },
    userProfile: ""
  }),
  methods: {
    async show(profile) {
      this.userProfile = profile;
      if (this.$refs.editForm) {
        this.$refs.editForm.reset();
        await this.$nextTick();
      }

      this.editDialog.phone = profile.phone;
      this.editDialog.name = profile.name;
      this.editDialog.permission = profile.permission;
      this.editDialog.clinic = profile.clinic;
      this.editDialog.info = profile.info;
      this.passwordSymbol = "●●●●●●●";
      this.editDialog.loading = false;

      if (this.editDialog.permission === "role_admin") {
        this.editDialog.permissionItems.push({
          text: "診所管理者",
          value: "role_admin"
        });
      }

      this.editDialog.show = true;
    },
    async showUpdatePasswordDialog() {
      if (this.$refs.updatePasswordForm) {
        this.$refs.updatePasswordForm.reset();
        await this.$nextTick();
      }

      this.updatePasswordDialog.showOrigin = false;
      this.updatePasswordDialog.showNew = false;
      this.updatePasswordDialog.showAgain = false;

      this.updatePasswordDialog.loading = false;
      this.updatePasswordDialog.show = true;
    },
    async updatePassword() {
      if (this.$refs.updatePasswordForm.validate()) {
        this.updatePasswordDialog.loading = true;
        await this.$ajax.put(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/staff/${
            this.editDialog.phone
          }/reset`,
          { newPwd: this.updatePasswordDialog.again }
        );

        this.updatePasswordDialog.show = false;
        this.updatePasswordDialog.loading = false;
      }
    },
    async updateProfile() {
      if (this.$refs.editForm.validate()) {
        this.editDialog.loading = true;
        await this.$ajax.put(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/users/${
            this.editDialog.phone
          }`,
          {
            name: this.editDialog.name,
            info: this.editDialog.info
          }
        );

        await this.$ajax.put(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/permission/${
            this.editDialog.phone
          }`,
          {
            permission: this.userProfile.permission,
            permissionNew: this.editDialog.permission
          }
        );

        this.editDialog.show = false;
        this.editDialog.loading = false;
        this.$emit("done");
      }
    }
  }
};
</script>
